import { useDispatch } from "react-redux";
import {
	changePage,
	changeResultsPerPage,
	changeSortColumn,
	changeSortDirection,
	clearSearch,
	paramsChanged,
} from "./actions";

export default function useSearch() {
	const dispatch = useDispatch();

	const onSearch = (data) => {
		dispatch(paramsChanged(data));
	};

	const onClearSearch = (e) => {
		dispatch(clearSearch());
		e.target.blur();
	};

	const onChangeResultsPage = (page) => {
		dispatch(changePage(page));
	};

	const onChangeResultsPerPage = (resultsPerPage) => {
		dispatch(changeResultsPerPage(resultsPerPage));
	};

	const onChangeResultsSort = (column) => {
		dispatch(changeSortColumn(column));
	};

	const onChangeResultsSortDirection = (direction) => {
		dispatch(changeSortDirection(direction));
	};

	return {
		onSearch,
		onClearSearch,
		onChangeResultsPage,
		onChangeResultsPerPage,
		onChangeResultsSort,
		onChangeResultsSortDirection,
	};
}
